document.getElementById("contact-form").addEventListener("submit", function(e) {
    e.preventDefault();
    const submit_button = document.getElementById("submit_button");
    const refresh_icon = document.getElementById("refresh_icon");
    const error_container = document.getElementById("error_container");
    const success_container = document.getElementById("success_container");
    const error_message = document.getElementById("error_message");
    error_container.classList.add("hidden");
    success_container.classList.add("hidden");
    submit_button.disabled = true;
    refresh_icon.classList.remove("hidden");
    const url = "https://zhbyi1xt3h.execute-api.us-east-1.amazonaws.com/dev/contact-form";
    const payload = {};
    const form = event.target;
    const formFields = form.elements;
    // construct payload
    for(let i = 0; i < formFields.length; i++){
        const name = formFields[i].name;
        const value = formFields[i].value;
        if (name !== "submit") payload[name] = value;
    }
    // construct request
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
    };
    fetch(url, requestOptions).then((response)=>{
        submit_button.disabled = false;
        refresh_icon.classList.add("hidden");
        if (response.ok) success_container.classList.remove("hidden");
        else {
            error_container.classList.remove("hidden");
            error_message.innerText = "please try again";
        }
    }).catch((error)=>{
        submit_button.disabled = false;
        refresh_icon.classList.add("hidden");
        error_message.innerText = error;
        error_container.classList.remove("hidden");
    });
});

//# sourceMappingURL=careers.752c2b3e.js.map
